export function useFileSystem() {
  const readFile = async (
    filepathOrBuffer: Buffer | string,
    lengthOrStart?: number,
    positionOrEnd?: number,
    encodingOrOptions?: any
  ): Promise<Buffer> => {
    return (filepathOrBuffer as Buffer).subarray(lengthOrStart, positionOrEnd);
  };

  return { readFile };
}
